<template>
  <div class="grid grid-cols-12 gap-4">
    <!--عنوان-->
    <div class="col-span-12">
      <div class="main__title">
        <h1>افزودن قسمت</h1>
      </div>
    </div>

    <!--عنوان و تصاویر-->
    <div class="col-span-12 grid grid-cols-12 gap-4">

      <div class="col-span-9 grid grid-cols-2 gap-4">

        <div class="col-span-1">
          <input v-model="name" type="text" class="form__input" placeholder="عنوان">
        </div>

        <div class="col-span-1">
          <input v-model="seo_title" type="text" class="form__input" placeholder="سئو عنوان">
          <SeoProgress :string="seo_title"
                       :min_perfect="50"
                       :max_perfect="60"/>
        </div>

        <div class="col-span-2">
                                    <textarea v-model="summary" rows="15" id="text" name="text" style="height: 400px"
                                              class="form__textarea"
                                              placeholder="توضیحات"></textarea>
        </div>

      </div>

      <div class="col-span-3 grid  gap-4">

        <div class="">
          <ImageSelector label="تصویر "
                         v-model:previewImage="file_preview"
                         @imagefile="(n) => file = n"
          />
        </div>

        <div class="">
          <CSelect label="وضعیت پرداخت"
                         :items="[{label:'رایگان',value:1},{label:'غیررایگان',value:2}]"
                         v-model="pay_type"
          />
        </div>

        <div class="">
          <CSelect label="وضعیت"
                   :items="[{label:'غیر فعال',value:0},{label:'فعال',value:1},{label:'بزودی',value:2}]"
                   v-model="status"
          />
        </div>

      </div>

    </div>

    <!--لینک های آپرا-->
    <div class="col-span-12">

      <div action="#" class="mr-3">
        <div class="row">


          <div class="col-span-12">
            <div class="grid grid-cols-12 gap-4 my-4" v-for="(link,index) in download_links">

              <div class="col-span-4">
                <input

                    v-model="link.title"
                    type="text" class="form__input"
                    placeholder="عنوان"/>

              </div>

              <div class="col-span-4">
                <input

                    v-model="link.url"
                    type="text" class="form__input"
                    placeholder="لینک"/>

              </div>

              <div class="col-span-2">
                <CButton @click="download_links.push({title:'',url:''})" color="primary">+</CButton>
              </div>

              <div class="col-span-2" v-if="download_links.length>1">
                <CButton @click="download_links.splice(index,1)" color="danger">-</CButton>
              </div>

            </div>
          </div>

          <!--          <div class="col-span-12">-->
          <!--            <hr>-->
          <!--            <div class="row" v-for="(link,index) in download_links">-->
          <!--              لینک دانلود-->
          <!--              <div class="col-3" >-->
          <!--                <input-->

          <!--                    v-model="link.title"-->
          <!--                    type="text" class="form__input"-->
          <!--                    placeholder="عنوان"/>-->

          <!--              </div>-->
          <!--              <div class="col-3" >-->
          <!--                <input-->

          <!--                    v-model="link.url"-->
          <!--                    type="text" class="form__input"-->
          <!--                    placeholder="لینک"/>-->

          <!--              </div>-->
          <!--              <div class="col-2" >-->
          <!--                <CButton @click="download_links.push({title:'',url:''})" color="primary">+</CButton>-->
          <!--              </div>-->
          <!--              <div class="col-2" v-if="download_links.length>1">-->
          <!--                <CButton @click="download_links.splice(index,1)" color="danger">-</CButton>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <hr>-->
          <!--          </div>-->


        </div>
      </div>
    </div>

    <!--ویرایش-->
    <div class="col-span-12">
      <button v-if="!isEdit" @click="insert_data()" type="button" class="form__btn">ثبت</button>
      <button v-else @click="insert_data()" type="button" class="form__btn">ویرایش</button>
    </div>

    <!--منابع-->
    <div class="col-span-12 mt-4" v-if="isEdit">
      <div class="main__title">
        <h2>منابع قسمت</h2>
      </div>

      <!--سرچ منابع-->
      <div class="col-span-12 grid grid-cols-12 gap-4">

        <div class="col-span-8">
          <treeselect
              :async="true"
              @select="select_url"
              :load-options="load_uploader"
              :normalizer="normalizer_uploader"
              placeholder="جستجو لینک"
              :searchable="true"
              :load-root-options="true"
              :auto-load-root-options="true"
              :clear-on-select="false"
              :show-count="true"
              :always-open="false"
              :default-expand-level="1"
              :min-input-length="0"
              :delay="0"
              :loading-text="'در حال جستجو...'"
              :no-options-text="'موردی یافت نشد'"
              :no-results-text="'موردی یافت نشد'"
          />

          <input v-model="sourceData.link"
                 type="text"
                 class="form__input mt-3"
                 style="direction: ltr;font-family: Arial !important;"
                 placeholder="لینک منبع">
        </div>

        <button type="button"
                :disabled="isLoading"
                class="form__btn col-span-4 "
                @click="handleSourceSubmit">
          {{ sourceData.editMode ? 'ویرایش' : 'افزودن' }} منبع
        </button>

      </div>


      <!-- Sources Table -->
      <div class="col-span-12 mt-4 pb-10">
        <Datatable
            :items="sources"
            :fields="sourceFields"
            style="overflow: auto"
            :items-per-page="20"
            hover
            height="300px"
            border
            striped
            sorter
            column-filter
            pagination
        >
          <template #row="{item,index}">
            <td>
              <div class="main__table-text">{{ index + 1 }}</div>
            </td>
          </template>
          <template #operation="{item}">
            <td>
              <div class="main__table-btns">
                <div @click="editSource(item)"
                     class="main__table-btn main__table-btn--edit">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                  </svg>
                </div>
                <div @click="deleteSource(item)"
                     class="main__table-btn main__table-btn--delete">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                  </svg>
                </div>
              </div>
            </td>
          </template>
        </Datatable>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import ImageSelector from "@/views/CustomComponent/ImageSelector";
import Treeselect, {ASYNC_SEARCH} from 'vue3-treeselect'
import 'vue3-treeselect/dist/vue3-treeselect.css'
import SeoProgress from "@/views/CustomComponent/SeoProgress.vue";
import Datatable from "@/views/customTable/Datatable";
import CButton from "@/views/CustomComponent/CButton.vue";
import CSelect from "@/views/CustomComponent/CSelect.vue";

// import the styles
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  name: 'EpisodeForm',

  components: {
    CSelect,
    CButton,
    SeoProgress,
    ImageSelector,
    Treeselect,
    Datatable
  },

  data() {
    return {
      // Episode data
      download_links: [{url: '', title: ''}],

      file_preview: '',
      file: null,
      name: '',
      seo_title: '',
      summary: '',
      duration: '',
      status: 0,
      pay_type: 2,
      status_form: 0,
      isLoading: false,

      // Sources data
      sources: [],
      sourceFields: [
        {key: 'row', label: 'ردیف'},
        {key: 'link', label: 'لینک'},
        {key: 'operation', label: 'عملیات'}
      ],
      sourceData: {
        link: '',
        editMode: false,
        editId: null
      },
      load_uploader({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            axios.post('search_upload_video', {
              search: searchQuery,

            }).then(function (response) {
              options = response.data;
              callback(null, options);
              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_uploader(node) {
        return {
          id: node.id,
          label: node.title,
        }
      },
    }
  },

  computed: {
    isEdit() {
      return this.status_form !== 0;
    },

    submitUrl() {
      return this.isEdit ? 'edit_episode' : 'insert_episode';
    }
  },

  watch: {
    status_form(newVal) {
      if (newVal !== 0) {
        this.loadSources()
      }
    }
  },

  mounted() {
    if (this.$route.params.episode_id != 0) {
      this.status_form = this.$route.params.episode_id
      this.get_data();
    }
  },

  methods: {
    select_url(node, id) {
      this.sourceData.link = node.url
    },
    async get_data() {
      try {
        const formData = new FormData();
        formData.append('id', this.status_form)

        const response = await this.axios.post('get_episode', formData);
        const content_data = response.data;

        this.file_preview = content_data.image
        this.name = content_data.name
        this.seo_title = content_data.seo_title
        this.summary = content_data.summary
        this.duration = content_data.duration
        this.status = content_data.view_status
        this.pay_type = content_data.pay_type
        this.download_links = content_data.poster_links
        if (this.download_links.length == 0) {
          this.download_links = [{url: '', title: ''}]
        }

        if (this.isEdit) {
          this.loadSources()
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('خطا در دریافت اطلاعات');
      }
    },

    validateForm() {
      if (!this.name.trim()) {
        this.$toast.error('لطفا عنوان را وارد کنید');
        return false;
      }

      return true;
    },

    async insert_data() {
      if (!this.validateForm()) return;

      this.isLoading = true;
      try {
        const formData = new FormData();

        if (this.isEdit) {
          formData.append("id", this.status_form)
        }

        formData.append("season_id", this.$route.params.season_id)
        formData.append("name", this.name)
        formData.append("seo_title", this.seo_title)
        formData.append("summary", this.summary)
        formData.append("summary", this.summary)
        formData.append("view_status", this.status)
        formData.append("pay_type", this.pay_type)
        formData.append("download_links", JSON.stringify(this.download_links))

        formData.append("duration", this.duration)
        formData.append("poster_image", this.file)

        await this.axios.post(this.submitUrl, formData);

        this.$toast.success('عملیات با موفقیت انجام شد');
        if (!this.isEdit) {
          this.resetForm();
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('خطا در ثبت اطلاعات');
      } finally {
        this.isLoading = false;
      }
    },

    resetForm() {
      this.name = '';
      this.seo_title = '';
      this.summary = '';
      this.file = null;
      this.file_preview = '';
      this.status = 0;
      this.duration = '';
    },

    // Sources Methods
    async loadSources() {
      try {
        const formData = new FormData()
        formData.append('episode_id', this.status_form)

        const response = await this.axios.post('get_episode_with_source', formData)
        this.sources = response.data.sources
      } catch (error) {
        console.error(error)
        this.$toast.error('خطا در بارگذاری منابع')
      }
    },

    async handleSourceSubmit() {
      if (!this.sourceData.link.trim()) {
        this.$toast.error('لطفا لینک را وارد کنید');
        return;
      }

      this.isLoading = true;
      try {
        const formData = new FormData()
        formData.append('link', this.sourceData.link)
        formData.append('episode_id', this.status_form)

        const url = this.sourceData.editMode
            ? 'update_episode_source'
            : 'insert_episode_source'

        if (this.sourceData.editMode) {
          formData.append('id', this.sourceData.editId)
        }

        await this.axios.post(url, formData)

        await this.loadSources()
        this.resetSourceForm()
        this.$toast.success('عملیات با موفقیت انجام شد')
      } catch (error) {
        console.error(error)
        this.$toast.error('خطا در ثبت اطلاعات')
      } finally {
        this.isLoading = false;
      }
    },

    editSource(item) {
      this.sourceData.link = item.link
      this.sourceData.editMode = true
      this.sourceData.editId = item.id
    },

    async deleteSource(item) {
      if (!confirm('آیا از حذف این منبع اطمینان دارید؟')) return

      this.isLoading = true;
      try {
        const formData = new FormData()
        formData.append('id', item.id)

        await this.axios.post('delete_episode_source', formData)

        await this.loadSources()
        this.$toast.success('حذف با موفقیت انجام شد')
      } catch (error) {
        console.error(error)
        this.$toast.error('خطا در حذف منبع')
      } finally {
        this.isLoading = false;
      }
    },
    resetSourceForm() {
      this.sourceData = {
        link: '',
        editMode: false,
        editId: null
      }
    }
  }
}
</script>

<!--<style scoped>-->
<!--.form {-->
<!--  //background-color: #28282d;-->
<!--  //padding: 20px;-->
<!--  //border-radius: 4px;-->
<!--  //margin-bottom: 20px;-->
<!--}-->

<!--.form__group {-->
<!--  position: relative;-->
<!--  margin-bottom: 20px;-->
<!--}-->

<!--.form__input,-->
<!--.form__textarea {-->
<!--  background-color: #151f30;-->
<!--  border: 1px solid transparent;-->
<!--  border-radius: 5px;-->
<!--  height: 46px;-->
<!--  position: relative;-->
<!--  color: #fff;-->
<!--  font-size: 16px;-->
<!--  width: 100%;-->
<!--  padding: 0 20px;-->
<!--  transition: 0.4s ease;-->
<!--}-->

<!--.form__textarea {-->
<!--  height: auto;-->
<!--  padding: 15px 20px;-->
<!--  resize: none;-->
<!--}-->

<!--.form__input:focus,-->
<!--.form__textarea:focus {-->
<!--  border-color: #2f80ed;-->
<!--}-->

<!--.form__btn {-->
<!--  display: flex;-->
<!--  justify-content: center;-->
<!--  align-items: center;-->
<!--  height: 46px;-->
<!--  width: 160px;-->
<!--  border-radius: 4px;-->
<!--  background: linear-gradient(90deg, #2f80ed 0%, #064caa 100%);-->
<!--  font-size: 14px;-->
<!--  color: #fff;-->
<!--  text-transform: uppercase;-->
<!--  font-weight: 500;-->
<!--  border: none;-->
<!--  cursor: pointer;-->
<!--  transition: 1.2s ease-in-out;-->
<!--}-->

<!--.form__btn:hover {-->
<!--  background: linear-gradient(-90deg, #2f80ed 0%, #064caa 100%);-->
<!--}-->

<!--.form__btn:disabled {-->
<!--  background: #21324e;-->
<!--  cursor: not-allowed;-->
<!--}-->

<!--.form__radio {-->
<!--  display: flex;-->
<!--  flex-wrap: wrap;-->
<!--  align-items: center;-->
<!--  margin-bottom: 20px;-->
<!--}-->


<!--.form__radio li:first-child {-->
<!--  color: rgba(255, 255, 255, 0.75);-->
<!--}-->

<!--.form__radio input:not(:checked),-->
<!--.form__radio input:checked {-->
<!--  position: absolute;-->
<!--  left: -9999px;-->
<!--}-->

<!--.form__radio label {-->
<!--  display: block;-->
<!--  padding: 0 15px 0 35px;-->
<!--  position: relative;-->
<!--  font-size: 16px;-->
<!--  color: rgba(255, 255, 255, 0.75);-->
<!--  cursor: pointer;-->
<!--}-->

<!--.form__radio input:not(:checked) + label:before,-->
<!--.form__radio input:checked + label:before {-->
<!--  content: '';-->
<!--  position: absolute;-->
<!--  left: 0;-->
<!--  top: 2px;-->
<!--  width: 20px;-->
<!--  height: 20px;-->
<!--  border: 1px solid rgba(255, 255, 255, 0.75);-->
<!--  border-radius: 50%;-->
<!--  background-color: transparent;-->
<!--}-->

<!--.form__radio input:not(:checked) + label:after,-->
<!--.form__radio input:checked + label:after {-->
<!--  content: '';-->
<!--  position: absolute;-->
<!--  left: 5px;-->
<!--  top: 7px;-->
<!--  width: 10px;-->
<!--  height: 10px;-->
<!--  border-radius: 50%;-->
<!--  background-color: #2f80ed;-->
<!--  transition: all 0.2s;-->
<!--}-->

<!--.form__radio input:not(:checked) + label:after {-->
<!--  opacity: 0;-->
<!--  transform: scale(0);-->
<!--}-->

<!--.form__radio input:checked + label:after {-->
<!--  opacity: 1;-->
<!--  transform: scale(1);-->
<!--}-->

<!--.main__table-text {-->
<!--  display: flex;-->
<!--  flex-direction: row;-->
<!--  justify-content: flex-start;-->
<!--  align-items: center;-->
<!--  font-size: 14px;-->
<!--  color: rgba(255, 255, 255, 0.7);-->
<!--  font-weight: 400;-->
<!--}-->

<!--.main__table-btns {-->
<!--  display: flex;-->
<!--  flex-direction: row;-->
<!--  justify-content: flex-start;-->
<!--  align-items: center;-->
<!--}-->

<!--.main__table-btn {-->
<!--  width: 30px;-->
<!--  height: 30px;-->
<!--  display: flex;-->
<!--  flex-direction: row;-->
<!--  justify-content: center;-->
<!--  align-items: center;-->
<!--  cursor: pointer;-->
<!--  margin-right: 10px;-->
<!--}-->

<!--.main__table-btn svg {-->
<!--  width: 20px;-->
<!--  height: auto;-->
<!--  fill: rgba(255, 255, 255, 0.7);-->
<!--  transition: fill 0.4s ease;-->
<!--}-->

<!--.main__table-btn&#45;&#45;edit:hover svg {-->
<!--  fill: #166bdd;-->
<!--}-->

<!--.main__table-btn&#45;&#45;delete:hover svg {-->
<!--  fill: #0756bf;-->
<!--}-->

<!--.mt-4 {-->
<!--  margin-top: 2rem;-->
<!--}-->
<!--</style>-->